<template>
  <div module-item :class="info.type">
    <div class="left">
      <cdn-img :src="info.value.left.pc" class="hidden-ml-down"/>
      <cdn-img :src="info.value.left.mobile" class="hidden-tp-up"/>
    </div>
    <div class="right">
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.right.pc}`" class="hidden-ml-down"/>
      <video loop muted autoplay playsinline :src="`${cdnHost}/${info.value.right.mobile}`" class="hidden-tp-up"/>
    </div>
    <div class="desc" v-if="info.value.desc" v-html="enterToBr(info.value.desc)"></div>
  </div>
</template>

<script>
import CdnImg from '@/views/components/CdnImg';

export default {
  name: 'DoubleImageVideo',
  components: { CdnImg },
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

